<template>
    <div class="custom-control custom-switch">
        <input type="checkbox" class="custom-control-input" :id="name" :checked="value" @change="checked($event.target.checked)">
        <label class="custom-control-label" :for="name">{{ label }}</label>
    </div>
</template>

<script>
export default {
  name: 'ToggleField',
  props: ['label', 'name', 'value'],
  methods: {
    checked (checked) {
      this.$emit('input', checked)
    }

  }
}
</script>
